(function scheduleTour(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewer.Config ||
    !global.NewHomeSource.Modules.tagManager) {
    return;
  }

  const previousScheduleTour = global.NewHomeSource.FullImageViewer.ScheduleTour;
  const languageResources = global.NewHomeSource.FullImageViewer.Config.languageResources;
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();
  const panelActionContainer = global.document.querySelector('[data-panel-actions]');
  const backButton = global.document.querySelector('[data-component="close-form"]');
  const closeButton = global.document.querySelector('[data-panel-form] [data-close-panel-action="true"]');
  const queryPanelForm = '[data-panel-form]';
  const queryForTourTypes = '[data-requestTourOptions]';
  const queryForInPersonTab = '[data-inPersonTour-actions]';
  const queryForSelfGuidedTab = '[data-selfGuidedTour-actions]';
  const queryForVideoChatTab = '[data-videoChat-actions]';
  const queryForSelfGuidedContent = '#nhs_selfGuidedTourSection';
  const panelForm = global.document.querySelector(queryPanelForm);
  const mainContainer = global.NewHomeSource.FullImageViewer.Config.fullImageViewer;
  const guidedTourConfiguration = global.document.querySelector('[data-guided-tour-configuration]');
  const messages = {};

  if (languageResources) {
    const translationKeys = Object.keys(languageResources);

    for (let i = 0; i < translationKeys.length; i += 1) {
      messages[translationKeys[i]] = languageResources[translationKeys[i]];
    }
  }

  /**
 * @private
 *
 * stopBubbling: stop propagation of events.
 * @param {event} event the event that fired this callback.
 */
  function stopBubbling(event) {
    event.stopPropagation();
  }

  function setUpEventClose(element) {
    const button = element;
    const leadEvents = global.NewHomeSource.Modules.tagManager.getFromDataLayer('leadEvents') || {};
    const step = panelForm.querySelector('[data-recommendations-box]') ? 'Step 3' : 'Step 2';
    button.dataset.ga4EventButton_name = leadEvents.ButtonNameClicked || '';
    button.dataset.ga4EventPosition = leadEvents.Position || '';
    button.dataset.ga4EventClick_target = step;
  }

  /**
   * @private
   *
   * closeButtonForm: supports the action of closing the form.
   * @param {event} event the event that fired this callback.
   */
  function closeButtonForm(event) {
    panelActionContainer.removeAttribute('hidden');
    panelForm.setAttribute('hidden', 'true');
    panelForm.querySelector('[data-form-container]').remove();

    if (event) {
      const leadEvents = global.NewHomeSource.Modules.tagManager.getFromDataLayer('leadEvents') || {};
      const target = event.target;
      event.preventDefault();

      target.dataset.ga4EventButton_name = leadEvents.ButtonNameClicked || '';
    }
  }

  /**
   * @private
   *
   * handleSelfGuidedTourContent: shows or hides the self guided tour content.
   */
  function handleSelfGuidedTourContent(isGoingToBeShown) {
    if (isGoingToBeShown && guidedTourConfiguration) {
      return;
    }

    const selfGuidedContent = panelForm.querySelector(queryForSelfGuidedContent);
    const elementsInSelector = panelForm
      .querySelectorAll('#nhs_scheduleTourSection, #nhs_contacBuilderSection, [data-commonFormSection]');
    for (let j = 0; j < elementsInSelector.length; j += 1) {
      elementsInSelector[j].style.display = isGoingToBeShown ? 'none' : 'block';
    }

    if (selfGuidedContent) {
      if (isGoingToBeShown) {
        if (global.lazyLoad) {
          global.lazyLoad.init();
        }
        selfGuidedContent.removeAttribute('hidden');
      } else {
        selfGuidedContent.setAttribute('hidden', '');
      }
    }
  }

  /**
   * @private
   *
   * bindScheduleTourTabsEvents: binds the functions to every tour tab: in person, video chat, self guided.
   */
  function bindScheduleTourTabsEvents() {
    const oneOnOneTabButton = panelForm.querySelector(queryForInPersonTab);
    const guidedTourTabButton = panelForm.querySelector(queryForSelfGuidedTab);
    const videoChatTabButton = panelForm.querySelector(queryForVideoChatTab);

    if (oneOnOneTabButton) {
      oneOnOneTabButton.addEventListener(eventToAttach, () => {
        handleSelfGuidedTourContent(false);
      });
    }

    if (guidedTourTabButton) {
      guidedTourTabButton.addEventListener(eventToAttach, () => {
        handleSelfGuidedTourContent(true);
      });
    }

    if (videoChatTabButton) {
      videoChatTabButton.addEventListener(eventToAttach, () => {
        handleSelfGuidedTourContent(false);
      });
    }
  }

  /**
   * @private
   *
   * setFormValuesToDefault: Cleans up the lead form fields.
   */
  function setFormValuesToDefault() {
    const formTextValues = panelForm.querySelectorAll('input[type="text"], input[type="email"]');
    for (let i = 0; i < formTextValues.length; i += 1) {
      formTextValues[i].value = '';
    }
  }

  /**
   * @private
   * Used to close the thank you modal.
   * @param {*} event The event.
   */
  function closeThankYouModal(event) {
    setUpEventClose(closeButton);
    closeButtonForm(event);
    const resetFormLink = document.querySelector('[data-reset-form-link]');
    resetFormLink.remove();
    closeButton.removeEventListener(eventToAttach, closeThankYouModal);
  }

  /**
   * @private
   *
   * sendFormFunction: Sends the lead.
   * @param {event} event the event that fired this callback.
   */
  function sendFormFunction(event) {
    const leadEvents = global.NewHomeSource.Modules.tagManager.getFromDataLayer('leadEvents') || {};
    const firedEvent = event;
    const formToGoBack = event.target.closest('[data-panel-form]').dataset.panelFormType === 'contactBuilder'
      ? '[data-contact-builder-panel-actions]' : '[data-schedule-panel-actions]';

    firedEvent.target.dataset.segmentButton_action =
      mainContainer.querySelector('#nhs_GetBrochure').dataset.segmentbutton_action;

    this.dataset.ga4IdentityButton_name = leadEvents.ButtonNameClicked || '';
    this.dataset.ga4IdentityPosition = leadEvents.Position || '';

    global.onClickSendForm(firedEvent, () => {
      const forgotPasswordLink = panelForm.querySelector('[data-forgotPassword]');

      if (forgotPasswordLink) {
        forgotPasswordLink.removeAttribute('hidden');
        forgotPasswordLink.querySelector('a').href += '&IsFullGallery=true';
      }

      panelActionContainer.setAttribute('hidden', '');
      backButton.setAttribute('hidden', '');
      closeButton.removeAttribute('hidden');

      const resetDataset = {
        event: 'true',
        ga4EventName: 'gallery_detail_pages',
        ga4EventButton_name: leadEvents.ButtonNameClicked || '',
        ga4EventClick_target: 'Reset form'
      };

      const existingResetLink = panelForm.querySelector('[data-reset-form-link]');
      if (!existingResetLink) {
        const resetFormLink = document.createElement('a');
        resetFormLink.setAttribute('data-reset-form-link', 'true');
        resetFormLink.innerHTML = messages.ResetForm;
        Object.assign(resetFormLink.dataset, resetDataset);
        panelForm.appendChild(resetFormLink);

        resetFormLink.onclick = function () {
          global.document.querySelector(formToGoBack).click();
          resetFormLink.remove();
          setFormValuesToDefault();
        };
      }

      closeButton.addEventListener(eventToAttach, closeThankYouModal);
      global.NewHomeSource.FullImageViewer.MoreInfoPanel.closePanelActions();
    });
  }

  /**
   * @private
   *
   * bindEvents: binds the events.
   * @param {event} event the event that fired this callback.
   */
  function bindEvents() {
    const getBrochureCta = mainContainer.querySelector('#nhs_GetBrochure');
    const form = mainContainer.querySelector('form');
    backButton.onclick = closeButtonForm;
    const liveOutSideChackBox = mainContainer.querySelector('[name=live-outside]');
    liveOutSideChackBox.onchange = global.onChangeToggleZipInput.bind(this, liveOutSideChackBox);
    global.setupLeadForms(form);
    // Create a new custom event with the name 'modalOpened' and the detail property containing the modal name
    const modalOpened = new CustomEvent('modalOpened', {
      detail: {
        modal: form
      }
    });

    // Dispatch the event from the element that opens the modal
    document.dispatchEvent(modalOpened);

    if (getBrochureCta) {
      getBrochureCta.onclick = sendFormFunction;
    }
    if (!global.Mailcheck && typeof global.NHS.loadJs === 'function') {
      global.NHS.loadJs(document.getElementById('CtaDependencies').value, '');
    } else if (global.NewHomeSource && global.NewHomeSource.EmailDomainValidator) {
      global.NewHomeSource.EmailDomainValidator();
    }
    bindScheduleTourTabsEvents();
  }

  /**
   * @constructs NewHomeSource.FullImageViewer.ScheduleTour
   */
  function ScheduleTour() {}

  /**
    * updateLegalConsentText will update the legal consent text by providing the right button
    * text of the form the user is interested in submitting.
    * @param {HTML} container where the legal consent text is placed.
    * @param {string} buttonText to be read in the legal consent text.
    */
  function updateLegalConsentText(container, buttonText) {
    const template = document.querySelector('[data-first-legal-consent-section-template]');
    const clone = template.content.cloneNode(true);
    const clonedFirstLegalConsentSection = clone.querySelector('[data-first-legal-consent-section]');
    const updatedtLegalConsentText =
        clonedFirstLegalConsentSection.innerHTML.replace('the button', `the ${buttonText} button`);

    clonedFirstLegalConsentSection.innerHTML = updatedtLegalConsentText;
    const currentLegalConsentSection = container.querySelector('[data-first-legal-consent-section]');
    currentLegalConsentSection.replaceWith(clonedFirstLegalConsentSection);
  }

  /**
   * @private
   *
   * setUpForm: prepares the form to be shown, either contact builder or schedule tour.
   * @param {isScheduleTour} bool a flag that indicates if the form is scheduleTour.
   */
  function setUpForm(isScheduleTour, event) {
    const formClone = document.querySelector('[data-component="full-image-viewer-scheduleTour-template"]')
      .content.cloneNode(true);
    let querySelectorForSectionToRemove = '';
    let formType = '';
    let formTitle = '';
    let formButton = '';

    if (isScheduleTour) {
      querySelectorForSectionToRemove = '#nhs_contacBuilderSection';
      formType = 'scheduleTour';
      formTitle = messages.TitleForGalleryForm;
      formButton = messages.TitleForGalleryForm;
    } else {
      querySelectorForSectionToRemove = '#nhs_scheduleTourSection';
      formType = 'contactBuilder';
      formTitle = messages.ContactTheBuilder;
      formButton = messages.SubmitRequest;
    }

    formClone.querySelector(querySelectorForSectionToRemove).remove();
    const remainingForm = panelForm.querySelector('#nhs_LeadForm');
    if (remainingForm) {
      remainingForm.remove();
    }

    panelForm.appendChild(formClone);
    panelForm.querySelector('[data-component="full-image-viewer-title"]').innerText = formTitle;
    panelForm.querySelector('[data-send-form] span').textContent = formButton;
    panelForm.setAttribute('data-panel-form-type', formType);
    panelForm.removeAttribute('hidden');
    panelForm.querySelector('[data-send-form] span').parentElement.dataset.segmentbutton_action =
      global.event.target.dataset.segmentEventButton_action;

    backButton.removeAttribute('hidden');
    closeButton.setAttribute('hidden', '');

    updateLegalConsentText(panelForm, formButton);

    if (isScheduleTour) {
      const phone = global.document.querySelector('[data-component="phone-number"]');
      const containerElement = mainContainer.querySelector('[data-slider-component]');
      panelForm.querySelector(queryForTourTypes).removeAttribute('hidden');
      global.initDatePicker(containerElement, phone, '/');
    } else {
      handleSelfGuidedTourContent(false);
      panelForm.querySelector(queryForTourTypes).remove();
      panelForm.querySelector('form').dataset.nterNowStatus = 'hidden';
    }

    if (event) {
      const parametersElement = panelForm.querySelector('[data-form-parameters]');
      const parameters = JSON.parse(parametersElement.innerHTML);
      const leadAction = event.target.closest('button').dataset.leadAction;

      if (leadAction) {
        parameters.LeadAction = leadAction;
        parametersElement.innerHTML = JSON.stringify(parameters);
      }
    }

    bindEvents();
  }

  /**
   * @public
   *
   * setUpContactBuilder: Sets up the contact builder form.
   */
  ScheduleTour.setUpScheduleTour = function setUpScheduleTour(event) {
    setUpForm(true, event);
  };

  /**
   * @public
   *
   * setUpContactBuilder: Sets up the contact builder form.
   */
  ScheduleTour.setUpContactBuilder = function setUpContactBuilder(event) {
    setUpForm(false, event);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.ScheduleTour to the previous script.
   */
  ScheduleTour.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.ScheduleTour = previousScheduleTour;
    return ScheduleTour;
  };

  const eventsConfiguration = {
    inputs: {
      callbacks: [stopBubbling],
      events: ['keydown'],
      elements: queryPanelForm,
    },
  };

  document.body.addEventListener('onConfirmationDisplayed', () => {
    closeThankYouModal();
    global.NewHomeSource.FullImageViewer.MoreInfoPanel.closePanelActions();
  });

  global.NewHomeSource.Event(eventsConfiguration);
  global.NewHomeSource.FullImageViewer.ScheduleTour = ScheduleTour;
}(window));
